import { ExternalLinks } from "@components/external-links";
import { Alert, Text } from "@flat-ui";

const appName = "Sphere XG/HoloBuilder Site Documentation";

/** Warning that informs customers that the Sphere XG app might not be installed in their Procore account */
export function ConnectDialogProcoreHint(): JSX.Element {
  return (
    <Alert
      title="Sphere XG App might not be installed in your Procore account"
      variant="warning"
      isCollapsible
      description={(
        <>
          <Text
            component="div"
            variant="bodyM"
          >
            We were unable to access the projects in your selected Procore company.
            It may be because the Sphere XG app is not installed in your Procore account.
            {" Look for the app named "}
            <ExternalLinks
              text={appName}
              link="procoreAppStore"
            />
            {" in the App Marketplace. "}
            <ExternalLinks
              text="See this article"
              link="procoreAppStoreArticle"
            />
            {" to learn how to install it."}
          </Text>
          <Text
            component="div"
            variant="bodyM"
            sx={{ marginTop: "8px" }}
          >
            <ExternalLinks
              text="Learn more"
              link="sphereXGProcoreIntegration"
            />
            {" about the Procore integration with Sphere XG."}
          </Text>
        </>
      )}
      sx={{
        mb: "8px",
      }}
    />
  );
}
